<template>
  <div class="note-preview">
    <SkeletonText :loading="loading && !note">

      <div class="note-preview-wrapper"
           v-if="note"
           @click="handleActions({action: 'edit', noteUid: note.uid})">
        <NoteCard :note="note"
                  @action="handleActions"
                  :show-updated="false"
                  :show-actions="false"
                  :mini-preview="true"/>
      </div>

      <div class="empty-state"
           v-else>
        <div class="empty-state-title empty-state-content">
          {{$t('client.matters.matter_page.no_notes')}}
        </div>
        <div class="empty-state-cta empty-state-content"
             @click="addNote">
          <v-icon>icon-Plus</v-icon>
          {{$t('client.matters.matter_page.add_note')}}
        </div>
      </div>

    </SkeletonText>
  </div>
</template>

<script>
  import {SkeletonText} from '@/modules/common/components';
  import NoteCard from '@/modules/matters/components/NoteCard/NoteCard'
  export default {
    name: "NotePreview",
    components: {
      NoteCard,
      SkeletonText
    },
    computed: {
      note() {
        return this.$store.getters['mattersModule/recentNote']
      },
      loading() {
        return this.$store.getters['mattersModule/summaryLoading']
      },
      perPage() {
        return this.$store.getters['mattersModule/perPage']
      }
    },
    methods: {
      addNote() {
        this.$frontageApi.send('matter_action', {action: 'add_note'});
      },
      handleActions({action, noteUid}) {
        switch (action) {
          case 'edit':
            this.$frontageApi.send('matter_action', {action: 'edit_note', noteUid, page: 1, perPage: this.perPage, origin: 'Recent note'});
            break;
          case 'clone':
            this.$frontageApi.send('matter_action', {action: 'clone_note', noteUid, origin: 'Notes tab'});
            break;
          case 'remove':
            const data = {title: this.$t('client.matters.matter_page.notes_tab.remove_note_dialog.title'), noteUid}
            this.$frontageApi.send('matter_action', {action: 'confirmation_dialog', data});
            break;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .v-card {
    box-shadow: none;
  }

  .v-card__text {
    padding: 0;
  }

  .note-card {
    cursor: pointer;
  }
</style>
